// S2-CC6: Poll LLM gateway status every 5 seconds
import { useState, useEffect, useCallback } from 'react';
import { apiFetch } from '../utils/api';

export interface LLMCallRecord {
  timestamp: string;
  caller: string;
  model: string;
  type: string;
  input_tokens: number;
  output_tokens: number;
  cached_tokens: number;
  cost_cents: number;
  duration_ms: number;
  job_id?: string;
  // S2-CC18: call-context tag mirrored from gateway.ts. Missing values render
  // as an em-dash in the Recent Calls table and aggregate as 'unknown' server-side.
  eval_type?: 'bare' | 'full' | 'readiness' | 'smoke' | 'production' | 'unknown';
}

export interface LLMStatus {
  paused: boolean;
  daily_calls: number;
  daily_cost_cents: number;
  api_key_status: 'active' | 'disabled' | 'missing';
  recent_calls: LLMCallRecord[];
}

export function useLLMStatus(pollInterval = 5000) {
  const [status, setStatus] = useState<LLMStatus | null>(null);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(() => {
    apiFetch<LLMStatus>('/v1/llm/status')
      .then(setStatus)
      .catch(err => setError(err instanceof Error ? err.message : 'Failed to fetch LLM status'));
  }, []);

  useEffect(() => {
    refresh();
    const timer = setInterval(refresh, pollInterval);
    return () => clearInterval(timer);
  }, [refresh, pollInterval]);

  return { status, error, refresh };
}
